export enum CdAState {
  completed = 'Completato',
  na = 'N.A.',
  notCompleted = 'Da Completare',
}
